import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function triggerTracking(dataLayerObject) {
  var dataLayer = window.dataLayer || [];
  Array.isArray(dataLayerObject) ? dataLayer.push.apply(dataLayer, _toConsumableArray(dataLayerObject)) : dataLayer.push(dataLayerObject);
}

export default triggerTracking;
//# sourceMappingURL=index.js.map